import { msg } from 'gt-react';
import type { ClaimRecordUnplacedRow, SD849ClaimSignal } from '@erp/rpc';

/**
 * The claim panel's chips (#7645): where the engine read a suggested claim.
 * A record over the whole vocabulary, so a new signal without a name here is a
 * type error rather than a blank chip. Decode with `useMessages()`.
 */
export const CLAIM_SIGNAL_LABELS: Record<SD849ClaimSignal, string> = {
  subject: msg('From subject', {
    context: '849 review claim chip: the VDM number was read from the subject',
  }),
  report_rows: msg('From report rows', {
    context: '849 review claim chip: the VDM number was read from the report',
  }),
  thread: msg('From thread', {
    context:
      '849 review claim chip: another email in the conversation answers this claim',
  }),
  matched_lines: msg('From matched lines', {
    context: '849 review claim chip: this email already decided lines here',
  }),
};

/**
 * Why a report row was not placed on a line (#7645), and the claim record's
 * row the old matcher left unmatched (SD-4).
 */
export const UNPLACED_REASON_LABELS: Record<
  ClaimRecordUnplacedRow['reason'],
  string
> = {
  no_vdm: msg('Names a VDM none of the claims carries', {
    context: '849 review unplaced row reason',
  }),
  ambiguous_claim: msg('Fits lines on more than one claim', {
    context: '849 review unplaced row reason',
  }),
  no_candidate_line: msg('No line on the claims fits it', {
    context: '849 review unplaced row reason',
  }),
  several_candidate_lines: msg('Several lines fit it', {
    context: '849 review unplaced row reason',
  }),
  claimed_amount_differs: msg('Claimed amount differs from ours', {
    context: '849 review unplaced row reason',
  }),
  line_already_settled: msg('Line already decided', {
    context: '849 review unplaced row reason',
  }),
  unreadable_amount: msg('Amount unreadable', {
    context: '849 review unplaced row reason',
  }),
  lump_row_not_paid_as_claimed: msg(
    "Covers several of our lines and isn't paid as claimed, so not split",
    {
      context:
        '849 review unplaced row reason: one supplier row answers several of our claim lines and is neither paid in full nor paid nothing, so it is left for review instead of being divided across the lines',
    },
  ),
  old_matcher_unmatched: msg('Not matched by the old matcher', {
    context:
      '849 claim record unplaced row reason: an older 849 whose rows the previous matching engine could not link to a claim line; a reviewer can link it by hand',
  }),
};
